<template>
  <div>
    <section>
      <h1 class="has-text-weight-semibold">Molecular structure:</h1>
      <img
        class="image"
        style="min-width: 200px; max-width: 280px;"
        :src="image"
        alt="Molecular structure image"
      >
    </section>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  max-width: 650px;
  height: auto
}
</style>
